import React, { useState } from 'react';
import CustomHeader from '../components/layout/CustomHeader';
import CustomFooter from '../components/layout/CustomFooter';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [status, setStatus] = useState({ success: null, message: '' });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus({ success: null, message: '' });
    try {
      const res = await fetch('/api/v1/forms/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      });
      const data = await res.json();
      if (data.success) {
        setStatus({ success: true, message: data.message || 'Message sent successfully!' });
        setFormData({ name: '', email: '', subject: '', message: '' });
      } else {
        setStatus({ success: false, message: data.message || 'Failed to send message. Please try again later.' });
      }
    } catch (err) {
      setStatus({ success: false, message: 'Failed to send message. Please try again later.' });
    }
  };

  return (
    <>
      <CustomHeader activePage="contact" />

      {/* Hero Section */}
      <section className="contact-hero">
        <h1>Contact IntelUniVen</h1>
        <p>We'd love to hear from you! Whether you have a question about our services, need support, or want to partner with us, our team is ready to help.</p>
      </section>

      {/* Contact Section */}
      <section className="contact-section">
        <form className="contact-form" onSubmit={handleSubmit}>
          <label htmlFor="name">Name</label>
          <input 
            type="text" 
            id="name" 
            name="name" 
            placeholder="Your Name" 
            value={formData.name}
            onChange={handleChange}
            required 
          />
          <label htmlFor="email">Email</label>
          <input 
            type="email" 
            id="email" 
            name="email" 
            placeholder="you@email.com" 
            value={formData.email}
            onChange={handleChange}
            required 
          />
          <label htmlFor="subject">Subject</label>
          <input 
            type="text" 
            id="subject" 
            name="subject" 
            placeholder="Subject" 
            value={formData.subject}
            onChange={handleChange}
            required 
          />
          <label htmlFor="message">Message</label>
          <textarea 
            id="message" 
            name="message" 
            rows="5" 
            placeholder="Type your message..." 
            value={formData.message}
            onChange={handleChange}
            required
          ></textarea>
          <button type="submit">Send Message</button>
          {status.message && (
            <div style={{ marginTop: '1rem', color: status.success ? 'green' : 'red', fontWeight: 500 }}>
              {status.message}
            </div>
          )}
        </form>
        <div className="contact-info">
          <h2>Contact Information</h2>
          <div className="info-item">
            <i className="fas fa-envelope"></i> 
            iuvsupport@inteluniven.in
          </div>
          <div className="info-item">
            <i className="fas fa-phone"></i> 
            +91-8484052442
          </div>
          <div className="info-item">
            <i className="fas fa-map-marker-alt"></i> 
            Pune, India
          </div>
          <div className="social-icons">
            <a href="https://www.facebook.com/profile.php?id=61575605834519" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
              <i className="fab fa-facebook-f"></i>
            </a>
            <a href="#" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
              <i className="fab fa-twitter"></i>
            </a>
            <a href="https://linkedin.com/company/inteluniven" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
              <i className="fab fa-linkedin-in"></i>
            </a>
            <a href="https://www.instagram.com/inteluniven/" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
              <i className="fab fa-instagram"></i>
            </a>
          </div>
          <div style={{marginTop: '18px', borderRadius: '16px', overflow: 'hidden', boxShadow: '0 4px 24px rgba(74,71,163,0.10)'}}>
            <iframe 
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3782.265588856342!2d73.9145563!3d18.5626487!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2c147b8b3a3bf%3A0x6f7fdcc8e4d6c77e!2sPune%2C%20Maharashtra!5e0!3m2!1sen!2sin!4v1625141234567!5m2!1sen!2sin" 
              width="100%" 
              height="200" 
              style={{border: 0}} 
              allowFullScreen="" 
              loading="lazy" 
              referrerPolicy="no-referrer-when-downgrade"
              title="IntelUniVen Location"
            ></iframe>
          </div>
        </div>
      </section>

      <CustomFooter />
    </>
  );
};

export default Contact;